import React from 'react';
import style from './index.module.css';
import AboutUsSection from '../../components/AboutUsSection';
import MyFooter from '../../components/MyFooter';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { teamList, processSteps } from '../../assets/constants';
import Avatar from '@mui/material/Avatar';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import { getImage } from '../../utils/utils';

const AboutUs = () => {
	const theme = useTheme();

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			style={{
				width: '100%',
				minHeight: '100vh',
				backgroundColor: theme.palette.background.default,
				color: theme.palette.text.primary,
			}}
		>
			<div className={style.contentWrapper}>
				{/* Welcome section */}
				<AboutUsSection />

				<motion.div 
					initial={{ y: 50, opacity: 0 }}
					whileInView={{ y: 0, opacity: 1 }}
					viewport={{ once: true }}
					transition={{ duration: 0.8, delay: 0.2 }}
					className={style.textSection}
				>
					<h2 className={style.subTitle} style={{ color: theme.palette.primary.main }}>Our Legacy</h2>
					<p className={style.paragraph}>
						We are one of the renowned Tentage and Decoration service
						providers in Ashta and nearby areas, having a solid foothold
						in wedding planning and tenting services comprising a wide
						range of packages to suit the requirements of any volume and
						mood.
					</p>
				</motion.div>

				{/* Our Process */}
				<section className={style.section}>
					<div className={style.sectionHeader}>
						<p style={{ color: theme.palette.primary.main }}>HOW WE WORK</p>
						<h1>Our Process</h1>
					</div>
					<div className={style.processGrid}>
						{processSteps.map((step, index) => (
							<motion.div 
								key={index}
								initial={{ opacity: 0, scale: 0.9 }}
								whileInView={{ opacity: 1, scale: 1 }}
								transition={{ delay: index * 0.1 }}
								viewport={{ once: true }}
								className={style.processCard}
							>
								<div className={style.stepNumber} style={{ backgroundColor: theme.palette.primary.main }}>
									{index + 1}
								</div>
								<h3>{step.title}</h3>
								<p>{step.description}</p>
							</motion.div>
						))}
					</div>
				</section>

				{/* Meet the Team */}
				<section className={style.section}>
					<div className={style.sectionHeader}>
						<p style={{ color: theme.palette.primary.main }}>THE VISIONARIES</p>
						<h1>Meet the Team</h1>
					</div>
					<div className={style.teamGrid}>
						{teamList.map((member, index) => (
							<motion.div 
								key={index}
								whileHover={{ y: -10 }}
								className={style.teamCard}
							>
								<Avatar 
									sx={{ 
                                        width: 120, 
                                        height: 120, 
                                        mb: 3, 
                                        bgcolor: theme.palette.primary.main,
                                        boxShadow: '0 10px 20px rgba(0,0,0,0.2)'
                                    }} 
								>
                                    <AccountCircleIcon sx={{ fontSize: 100, color: '#fff' }} />
                                </Avatar>
								<h2>{member.name}</h2>
								<p className={style.role} style={{ color: theme.palette.secondary.main }}>{member.role}</p>
								<p className={style.bio}>{member.bio}</p>
                                {member.phone && (
                                    <motion.a 
                                        href={`tel:${member.phone}`}
                                        whileHover={{ scale: 1.1 }}
                                        className={style.teamPhone}
                                        style={{ color: theme.palette.primary.main }}
                                    >
                                        <PhoneIcon sx={{ fontSize: 20, mr: 1 }} />
                                        {member.phone}
                                    </motion.a>
                                )}
							</motion.div>
						))}
					</div>
				</section>
			</div>

			{/* Footer Section */}
			<MyFooter />
		</motion.div>
	);
};

export default AboutUs;
